import { Box } from '@material-ui/core';
import { RemoveIcon } from './SvgIcons';

interface IFilterTag {
  label: string;
  clickOnRemove: () => void;
}

const FilterTag: React.FC<IFilterTag> = ({ label, clickOnRemove }) => (
  <Box
    display="flex"
    justifyContent="left"
    textAlign="center"
    color="#323444"
    style={{ gap: 6, textTransform: 'capitalize' }}
  >
    <Box
      bgcolor="#F4F4F5"
      borderRadius={16}
      padding="2px 16px"
      height="20px"
      width="max-content"
    >
      {label}
    </Box>
    <Box onClick={clickOnRemove} style={{ cursor: 'pointer' }}>
      {RemoveIcon}
    </Box>
  </Box>
);

export default FilterTag;
